module.exports = __webpack_public_path__ + "img/delivered-box-verification.d258e0ec.svg";